/**
 * URLクエリ文字列をオブジェクトで返す
 * @returns {object} URLクエリ パラメータが入ったオブジェクト
 */
export const getUrlParams = () =>
  Object.fromEntries(new URLSearchParams(window.location.search))

export default getUrlParams
